import * as React from 'react';
import { format } from 'date-fns';
import { IComment } from 'next-common';
import { Icon, IconType } from '@repo/ui/components';

export interface ITypedComment extends IComment {
  type: string;
}

export interface ICommentItemProps {
  comment: ITypedComment;
  employeeName?: string;
}

export const Comment = (props: ICommentItemProps) => (
  <div className="flex py-3 px-6 gap-2 rounded-sm border border-neutralPlus bg-white">
    <div className="flex-1 flex flex-col gap-4">
      <div className="flex flex-col">
        <div className="font-extrabold text-black text-base/[175%]">
          {props.comment.type === 'sale' ? 'Selgerkommentar' : 'Kommentar til DNB Finans AS'}
        </div>
        <div className="text-concrete text-sm/[170%] font-semibold">
          {format(props?.comment?.timestamp, 'dd. MMM yyyy, HH:mm')}
        </div>
      </div>
      <div className="text-black text-base/[175%] font-semibold break-words">{props.comment.text}</div>
    </div>
    <div className="flex justify-between text-concrete mt-2 mb-8">
      <div className="flex gap-0.5">
        <div className="w-5 h-5 flex">
          <Icon icon={IconType.NewNextUser} aria-hidden className="w-full h-full" />
        </div>
        <div className="font-semibold text-concrete text-sm/[170%]">{props.employeeName ?? 'Ukjent'}</div>
      </div>
    </div>
  </div>
);
